import { corporateIdSchema } from '@df/common';
import { z } from 'zod';
import { accountReferenceSchema, basAccountSchema } from './account';
import { allAccountBalancesSchema } from './account_balance';
import { bookYearMetadataSchema } from './book_year_metadata';
import { ledgerMetadataSchema } from './ledger_metadata';
import { bookYearSchema } from './periods';

const activeAccountInfoSchema = z.object({
  account: accountReferenceSchema,
  basAccount: basAccountSchema,
  name: z.string(),
  changedMapping: z.boolean(),
});
type ActiveAccountInfo = z.infer<typeof activeAccountInfoSchema>;

const companyMetadataSchema = z.object({
  companyName: z.string(),
  corporateId: corporateIdSchema,
  accountNames: z.map(accountReferenceSchema, z.string()),
  activeAccounts: z.map(accountReferenceSchema, activeAccountInfoSchema),
  balances: allAccountBalancesSchema(bookYearSchema),
  years: z.map(bookYearSchema, bookYearMetadataSchema),
});
type CompanyMetadata = z.infer<typeof companyMetadataSchema>;

const companySchema = z.object({
  metadata: companyMetadataSchema,
  bookYears: z.map(bookYearSchema, ledgerMetadataSchema),
});

const _companiesSchema = z.map(z.string(), companySchema);
type Companies = z.infer<typeof _companiesSchema>;

export { companyMetadataSchema, type ActiveAccountInfo, type Companies, type CompanyMetadata };
